import { render, staticRenderFns } from "./Ren.vue?vue&type=template&id=6d1465b0&scoped=true&"
import script from "./Ren.vue?vue&type=script&lang=js&"
export * from "./Ren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1465b0",
  null
  
)

export default component.exports